// import React, { useState } from 'react';
// import { login } from '../services/api'; // Importing from api.js
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios'; // Import axios for forgot password request
// import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import eye icons from react-icons (ensure react-icons is installed: npm i react-icons)

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false); // State for password visibility
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [isForgotPassword, setIsForgotPassword] = useState(false); // State to toggle forgot password mode
//   const [resetEmail, setResetEmail] = useState(''); // State for reset email input
//   const [resetMessage, setResetMessage] = useState(''); // State for reset success/error message
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);
//     try {
//       const res = await login(username, password);
//       if (res.data.success) {
//         // Token, user_id, and role are stored in api.js login function
//         // Store additional fields as needed
//         localStorage.setItem('username', res.data.username || username);
//         localStorage.setItem('email', res.data.email || '');
//         localStorage.setItem('employee_name', res.data.employee_name || '');
//         localStorage.setItem('employee_code', res.data.employee_code || '');
//         navigate('/dashboard');
//       } else {
//         setError(res.data.error || 'Login failed');
//       }
//     } catch (err) {
//       console.error('Login error:', err);
//       setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     setResetMessage('');
//     setError('');
//     setLoading(true);

//     try {
//       // Assuming backend has /auth/forgot-password endpoint that sends a reset email with verification link/token
//       const res = await axios.post(`${process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net'}/auth/forgot-password`, { email: resetEmail });
//       if (res.data.success) {
//         setResetMessage('Reset link sent to your email. Please check your inbox.');
//       } else {
//         setError(res.data.error || 'Failed to send reset email.');
//       }
//     } catch (err) {
//       console.error('Forgot password error:', err);
//       setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100">
//       <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
//         <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">{isForgotPassword ? 'Reset Password' : 'Login'}</h2>
//         {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
//         {resetMessage && <p className="text-green-500 mb-4 text-center">{resetMessage}</p>}

//         {!isForgotPassword ? (
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">Username or Email:</label>
//               <input
//                 type="text"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//                 disabled={loading}
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">Password:</label>
//               <div className="relative">
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//                   disabled={loading}
//                   required
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
//                   disabled={loading}
//                 >
//                   {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
//                 </button>
//               </div>
//             </div>
//             <button
//               type="submit"
//               className={`w-full bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-600 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
//               disabled={loading}
//             >
//               {loading ? 'Logging in...' : 'Login'}
//             </button>
//             <p className="text-center mt-4">
//               <button
//                 type="button"
//                 onClick={() => setIsForgotPassword(true)}
//                 className="text-indigo-500 hover:underline"
//               >
//                 Forgot Password?
//               </button>
//             </p>
//           </form>
//         ) : (
//           <form onSubmit={handleForgotPassword} className="space-y-6">
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">Enter your Email:</label>
//               <input
//                 type="email"
//                 value={resetEmail}
//                 onChange={(e) => setResetEmail(e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//                 disabled={loading}
//                 required
//               />
//             </div>
//             <button
//               type="submit"
//               className={`w-full bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-600 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
//               disabled={loading}
//             >
//               {loading ? 'Sending...' : 'Send Reset Link'}
//             </button>
//             <p className="text-center mt-4">
//               <button
//                 type="button"
//                 onClick={() => setIsForgotPassword(false)}
//                 className="text-indigo-500 hover:underline"
//               >
//                 Back to Login
//               </button>
//             </p>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { login } from '../services/api';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(username, password);
      if (res.data.success) {
        localStorage.setItem('username', res.data.username || username);
        localStorage.setItem('email', res.data.email || '');
        localStorage.setItem('employee_name', res.data.employee_name || '');
        localStorage.setItem('employee_code', res.data.employee_code || '');
        navigate('/dashboard');
      } else {
        setError(res.data.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setResetMessage('');
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE || 'https://api.zauntrip.net'}/auth/forgot-password`, { email: resetEmail });
      if (res.data.success) {
        setResetMessage('Reset link sent to your email. Please check your inbox.');
      } else {
        setError(res.data.error || 'Failed to send reset email.');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-8 sm:py-12">
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md w-full max-w-sm sm:max-w-md">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-5 sm:mb-6 text-center">
          {isForgotPassword ? 'Reset Password' : 'Login'}
        </h2>
        {error && <p className="text-red-500 mb-4 text-center text-sm">{error}</p>}
        {resetMessage && <p className="text-green-500 mb-4 text-center text-sm">{resetMessage}</p>}

        {!isForgotPassword ? (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">Username or Email:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
                disabled={loading}
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">Password:</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
                  disabled={loading}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                  disabled={loading}
                >
                  {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              className={`w-full bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-600 transition-colors text-sm sm:text-base font-medium ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <p className="text-center mt-2">
              <button type="button" onClick={() => setIsForgotPassword(true)} className="text-indigo-500 hover:underline text-sm">
                Forgot Password?
              </button>
            </p>
          </form>
        ) : (
          <form onSubmit={handleForgotPassword} className="space-y-5">
            <div>
              <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">Enter your Email:</label>
              <input
                type="email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
                disabled={loading}
                required
              />
            </div>
            <button
              type="submit"
              className={`w-full bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-600 transition-colors text-sm sm:text-base font-medium ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <p className="text-center mt-2">
              <button type="button" onClick={() => setIsForgotPassword(false)} className="text-indigo-500 hover:underline text-sm">
                Back to Login
              </button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;